
import React from 'react'
import Chart from 'react-apexcharts'
import { COLORS } from './chart.constant'
import jwt_decode from 'jwt-decode';

const BasicColumn = () => {
    const data = [
        {
            name:  (((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).location : 'Orlando' ) ,
            data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
        },
    ]

    return (
        <Chart
            options={{
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                    },
                },
                colors: COLORS,
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent'],
                },
                xaxis: {
                    categories: [
                        'Dec',
                        'Jan',
                        'Feb',
                        'Mar',
                        'Apr',
                        'May',
                        'Jun',
                        'Jul',
                        'Aug',
                    ],
                },
                fill: {
                    opacity: 1,
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val} thousands`,
                    },
                },
            }}
            series={data}
            height={300}
            width={500}
            type="bar"
        />
    )
}

export default BasicColumn

